/** Vérifications de saisie communes aux fiches. Chaque fonction rend un message, ou `undefined`. */

export function exiger(valeur: string, message = 'Champ obligatoire.'): string | undefined {
  return valeur.trim() === '' ? message : undefined;
}

export function verifierEmail(valeur: string, obligatoire = false): string | undefined {
  const v = valeur.trim();
  if (v === '') return obligatoire ? 'Adresse e-mail obligatoire.' : undefined;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ? undefined : 'Adresse e-mail invalide.';
}

/**
 * Un numéro joignable : dix chiffres commençant par 0 (métropole, outre-mer),
 * ou un numéro international en +. Espaces, points et tirets tolérés.
 */
export function verifierTelephone(valeur: string, obligatoire = false): string | undefined {
  const v = valeur.replace(/[\s.\-()]/g, '');
  if (v === '') return obligatoire ? 'Téléphone obligatoire.' : undefined;
  return /^(0\d{9}|\+\d{8,15})$/.test(v) ? undefined : 'Numéro invalide : 06 12 34 56 78.';
}

export function verifierCodePostal(valeur: string, obligatoire = false): string | undefined {
  const v = valeur.replace(/\s/g, '');
  if (v === '') return obligatoire ? 'Code postal obligatoire.' : undefined;
  return /^\d{5}$/.test(v) ? undefined : 'Cinq chiffres attendus.';
}

/** Quatorze chiffres ; les espaces sont tolérés. Vide accepté (une exploitation individuelle peut ne pas en avoir sous la main). */
export function verifierSiret(valeur: string): string | undefined {
  const v = valeur.replace(/\s/g, '');
  if (v === '') return undefined;
  return /^\d{14}$/.test(v) ? undefined : 'Un SIRET compte quatorze chiffres.';
}

/** « 49876543200018 » → « 498 765 432 00018 ». */
export function formaterSiret(valeur: string): string {
  const v = valeur.replace(/\s/g, '');
  if (!/^\d{14}$/.test(v)) return valeur.trim();
  return `${v.slice(0, 3)} ${v.slice(3, 6)} ${v.slice(6, 9)} ${v.slice(9)}`;
}

/** Garde les erreurs présentes ; un objet vide veut dire « formulaire valide ». */
export function erreursPresentes<T extends Record<string, string | undefined>>(
  erreurs: T
): Partial<Record<keyof T, string>> {
  return Object.fromEntries(Object.entries(erreurs).filter(([, m]) => m !== undefined)) as Partial<
    Record<keyof T, string>
  >;
}
